module.exports = __webpack_public_path__ + "static/media/1-5.9c2138b7.png";